import { connect } from 'react-redux';

import { BOOTSTRAP_CIS_FORM } from 'store/form';

import {
  getSamplesMean,
  getSamplesStdev
} from 'store/scenes/bootstrapCIs/samples/selectors';

import CIFieldsComponent from 'components/CIFields';

const mapStateToProps = state => ({
  form: BOOTSTRAP_CIS_FORM,
  mean: getSamplesMean(state),
  stdev: getSamplesStdev(state)
});

export default connect(mapStateToProps)(
  CIFieldsComponent
);
